<template>
  <!-- popup_dim -->
  <div class="popup_dim">
    <slot />
  </div><!-- popup_dim // -->
</template>

<script>
export default {
  name: 'WinLayerPop'
}
</script>
